// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_2OAMZpP6VyBM5ZikN_7B4S","spaceLeft":"_2aEP2QZtwDLDFVpia8fQXN","spaceBoth":"_1cm8D_U6HtunmDk1f3arI7","spaceRight":"_9juC3N3-nWDtCiMcq-Pwf","OasisAccount":"_81-385aooSQhhN-SbuMbY","label":"_3Rrl_4UkfECTXD1jcjcgfN","AccountSelection":"_2eTNlenAxqPP17wxWAHAv7","glyphicon":"_1x6Pb0r8InhnQnOHjB_o7a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisAccount.scss
// module id = 1044
// module chunks = 0